import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from 'commons-ui';
import { ICustomResponse, ISegmentConfigData, ITDSConfig } from '../../utils/type';
import useService from '../../utils/useService';
import { getFormDefaults } from '../../utils/formConfig';
import { dehydrateFormData } from '../../utils/formDataParser';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history: any = useHistory();
	const { requestCreateConfig } = useService();
	const createOffer = (tdsConfig: ITDSConfig) => {
		setShowLoader(true);
		requestCreateConfig(app.appName, { ...tdsConfig }).then(
			(res: ICustomResponse) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the TDS Config', { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Config Created');
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err?.response?.data?.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: ISegmentConfigData) => {
		createOffer(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};
	return {
		data: getFormDefaults('', 0, 0),
		tdsOfferSegmentsData: history?.location?.state?.tdsOfferSegmentsData,
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useCreate;
